import { FC } from 'react';
import { Flex, InputRightElement, Stack } from '@chakra-ui/react';

import IconButton from 'components/_core/IconButton';
import SearchBar from 'components/SearchBar';

import { useFilters } from '../../../../hooks/useFilters';
import locales from './locales';

const Filters: FC = () => {
  const { filters, updateFilters } = useFilters();

  return (
    <Stack marginBottom="space-24">
      <Flex gap="space-16">
        <SearchBar
          flexGrow={1}
          onChange={(q) => updateFilters({ q })}
          placeholder={locales.searchbar}
          value={filters.q}
        >
          {filters.q ? (
            <InputRightElement>
              <IconButton
                aria-label={locales.clear}
                icon="cross"
                onClick={() => updateFilters({ ...filters, q: '' })}
                variant="inline-secondary"
              />
            </InputRightElement>
          ) : null}
        </SearchBar>
      </Flex>
    </Stack>
  );
};

export default Filters;
